import { Component } from 'react';

export class AwaitingFundsIllustrationSVG extends Component<{
    className?: string;
}> {
    render() {
        const { className } = this.props;

        return (
            <svg
                className={className}
                width="806"
                height="404"
                viewBox="0 0 806 604"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M326.913 349.968C326.913 349.968 350.882 341.542 345.592 335.401C345.592 335.401 366.981 358.504 366.981 387.969C366.981 387.969 369.52 401.59 348.061 423.213C326.601 444.836 307.932 459.151 307.468 471.603C307.005 484.056 307.7 529.688 307.7 529.688L306.471 533.282H194.961C194.961 533.282 189.46 523.215 191.404 497.927C193.349 472.64 192.906 435.675 218.204 415.884C225.911 409.713 242.606 403.351 249.104 404.73C249.104 404.73 249.245 410.056 270.957 409.502L283.792 408.052L288.004 409.713C288.004 409.713 295.056 417.545 304.587 413.81C314.118 410.076 333.2 400.633 333.925 370.775C332.938 353.582 326.913 349.968 326.913 349.968Z"
                    fill="#FFDCDC"
                />
                <path
                    d="M196.241 535.355C196.241 535.355 186.75 526.849 193.934 467.516C201.117 408.183 239.322 406.109 246.414 404.408C253.507 402.707 252.651 377.48 252.369 376.352C252.369 376.352 229.388 300.671 265.416 295.285C301.444 289.9 303.147 304.919 302.865 315.127C302.582 325.334 307.69 338.371 307.69 346.585C307.69 354.81 305.141 372.376 288.115 379.745C282.443 382.292 272.226 383.711 272.226 383.711"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M221.197 441.071C209.449 503.806 218.587 535.365 218.587 535.365"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M288.115 379.755C288.115 379.755 278.191 408.103 291.803 412.915C305.414 417.736 323.287 409.925 331.518 386.761C339.749 363.598 324.707 345.176 317.333 338.089C309.958 331.002 304.285 325.616 307.691 322.788C311.096 319.949 318.189 327.891 319.61 327.036"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M304.568 306.621C304.568 306.621 313.364 309.741 328.396 319.093C343.428 328.445 366.409 358.786 366.973 387.979C367.537 417.173 309.384 453.161 307.682 469.036C305.979 484.911 307.682 533.282 307.682 533.282"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M248.903 402.506C248.903 402.506 244.893 414.344 286.221 407.68"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M335.768 266.656C342.931 273.813 350.518 290.464 296.052 310.305C290.662 312.852 288.677 336.096 277.615 338.361C266.553 340.626 261.727 344.592 264.004 350.27C266.271 355.937 274.502 355.373 273.928 359.058C273.363 362.742 267.973 378.617 252.367 376.352C236.761 374.087 225.417 300.107 247.541 290.474C269.666 280.84 294.35 270.069 304.556 264.109C314.772 258.16 312.787 271.196 316.182 272.042C319.608 272.897 330.096 260.988 335.768 266.656Z"
                    fill="#0C2340"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M125.332 533.282H682.278"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M596.41 150.567C596.41 143.903 590.999 138.507 584.34 138.507C580.904 138.507 577.811 139.947 575.605 142.252C573.298 137.581 568.492 134.37 562.93 134.37C555.122 134.37 548.785 140.702 548.785 148.503C548.785 149.208 548.856 149.893 548.956 150.577H596.41V150.567Z"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M388.04 136.283C388.03 136.334 388.03 136.374 388.03 136.374C388.019 136.344 388.03 136.313 388.04 136.283Z"
                    fill="#DADFE0"
                />
                <path
                    d="M522.38 136.384C522.38 136.384 522.369 136.344 522.369 136.293C522.359 136.313 522.369 136.344 522.38 136.384Z"
                    fill="#DADFE0"
                />
                <path
                    d="M458.432 69.6412C457.365 69.5909 456.276 69.5707 455.198 69.5707C454.07 69.5707 452.962 69.6009 451.854 69.6513H451.843C417.729 71.3324 390.305 98.4218 388.149 132.377C388.119 132.981 388.905 133.222 389.237 132.709C392.27 127.917 400.602 124.474 410.405 124.474C421.105 124.474 430.051 128.561 432.268 134.038C432.368 134.289 432.61 134.41 432.842 134.38C433.054 134.37 433.245 134.249 433.336 134.038C435.562 128.571 444.499 124.474 455.198 124.474C465.888 124.474 474.835 128.561 477.061 134.038C477.132 134.219 477.273 134.33 477.434 134.37C477.696 134.44 477.998 134.34 478.119 134.038C480.346 128.571 489.282 124.474 499.982 124.474C509.785 124.474 518.127 127.907 521.149 132.709C521.482 133.222 522.268 132.981 522.227 132.377C520.092 98.3815 492.597 71.2619 458.432 69.6412Z"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                />
                <path
                    d="M402.133 236.255V210.836L420.016 204.756L424.036 203.387L449.102 194.871V220.943"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M449.104 220.943V194.871L470.573 202.169L474.603 203.538L478.623 204.907L496.073 210.836V236.255"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M402.133 236.265C402.133 236.265 443.128 218.336 449.102 220.943C472.557 231.191 496.072 236.265 496.072 236.265L449.102 246.855L402.133 236.265Z"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinejoin="round"
                />
                <path
                    d="M426.102 241.66C445.969 241.66 472.769 229.772 472.769 229.772"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M449.828 271.387V288.289"
                    stroke="#FFD5AE"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M423.08 261.411L413.66 279.4"
                    stroke="#FFD5AE"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M388.764 210.373H371.848"
                    stroke="#FFD5AE"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M403.805 245.687L387.836 257.807"
                    stroke="#FFD5AE"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M472.588 263.626L480.849 279.4"
                    stroke="#FFD5AE"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M505.744 210.373H522.66"
                    stroke="#FFD5AE"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M491.428 246.241L506.671 257.807"
                    stroke="#FFD5AE"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M522.237 132.377C522.237 132.377 493.634 197.88 484.113 206.779"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M388.15 132.377C388.15 132.377 403.223 197.146 410.728 207.917"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M433.336 134.038C433.336 134.038 425.537 175.049 428.943 200.176"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M477.434 134.36C477.434 134.36 471.611 192.817 467.238 201.031"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M470.573 202.169C470.573 202.169 471.681 217.984 469.605 228.07"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M480.559 205.38C480.559 205.38 481.667 221.195 479.592 231.282"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M420.016 204.756C420.016 204.756 418.192 225.544 421.205 228.453"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinejoin="round"
                />
                <path
                    d="M430.706 201.555C430.706 201.555 428.308 222.655 430.706 225.876"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M378.065 99.2775C378.196 98.603 378.276 97.9084 378.276 97.2037C378.276 91.4355 373.591 86.7545 367.818 86.7545C365.824 86.7545 363.97 87.3183 362.378 88.2947C360.454 77.6543 351.144 69.5707 339.931 69.5707C331.276 69.5707 323.75 74.3826 319.882 81.4695C317.312 80.0602 314.371 79.2549 311.237 79.2549C301.313 79.2549 293.273 87.2881 293.273 97.2037C293.273 97.9084 293.324 98.603 293.404 99.2775H378.065Z"
                    stroke="#0C2340"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        );
    }
}
